<div class="packages-container">

    <div style="display: flex; justify-content: space-between; align-items: center">
        <h4>Building Types</h4>
        <!-- <button class="new"
                (click)="openNewPackage()"
                mat-button>
            <mat-icon style="margin-bottom: 3px">add</mat-icon>
            New Building Type
        </button> -->
    </div>
    <div *ngIf="project.packageProjects && project.packageProjects.length > 0">
        <div *ngFor="let p of project.packageProjects" class="package-item">
            <img *ngIf="p.logo" [src]="SERVER_URL + 'images/' + p.projectCode + '/images/' + p.logo.fileName"
                style="width: 120px; height: 120px; object-fit: contain">
            <img *ngIf="!p.logo" src="./assets/images/pkg-default.svg"
                style="width: 120px; height: 120px; object-fit: contain">
            <div style="margin-left: 30px; display: flex; flex-direction: column; justify-content: space-between">
                <div style="display: flex">
                    <div class="name">
                        <div class="title">Building Type Name</div>
                        <div class="content">{{p.name}}</div>
                    </div>
                    <div class="address">
                        <div class="title">Building Type Address</div>
                        <div class="content">{{p.addressLine2}}, {{p.area}} {{p.state}} {{p.postCode}}</div>
                    </div>
                </div>
                <div class="btn-holder">
                    <button class="image-btn" (click)="openImagePackage(p)">
                        <img src="./assets/images/camera-btn.svg">
                        Image
                    </button>
                    <button class="file-btn">
                        <img src="./assets/images/file-btn.svg">
                        Document</button>
                    <button class="floorplan-btn" (click)="openFloorplanPackage(p)">
                        <img src="./assets/images/floorplan-btn.svg">
                        Floorplan</button>
                    <button class="property-btn" (click)="openPropertyPackage(p)">
                        <img src="./assets/images/property-btn.svg">
                        Property</button>
                    <!--                    <button class="link-lot-btn" (click)="openLinkLot(p)">-->
                    <!--                        <img src="./assets/images/property-btn.svg">-->
                    <!--                        Lot</button>-->
                </div>
                <img src="./assets/images/edit_blue.svg" class="edit" (click)="openEditPackage(p)">
                <img src="./assets/images/delete-pkg.svg" class="delete" (click)="openDeletePackage(p)">
            </div>
        </div>
    </div>
    <div *ngIf="project.packageProjects && project.packageProjects.length === 0"
        style="display: flex; flex-direction: column; align-items: center">
        <img src="./assets/images/empty.svg" style="width: 400px; height: 400px; margin-top: -100px">
        <p style="margin-top: -50px">No H&L package has been added to this project.</p>
    </div>
</div>